import React from "react";
import { IPermissionContext, PermissionContext } from "./PermissionContext";
import { withContextFactory } from "../contexts.utils";

export interface WithPermissionContext {
    permissionContext: IPermissionContext;
}

export const withPermissionContext = withContextFactory<WithPermissionContext>(PermissionContext, "permissionContext");
